import styled from '@emotion/styled';
import { theme } from '../../theme';
import { Spinner } from '../spinner';
export const CHAT_BUBBLE_MAX_WIDTH = '65ch';
export const Wrapper = styled.div `
	display: flex;
	flex-direction: column;
	align-items: ${({ author }) => author === 'host' ? 'flex-end' : 'flex-start'};
	justify-content: center;
`;
export const SharedStyledChatBubble = styled.div `
	border-radius: 18px;
	max-width: ${CHAT_BUBBLE_MAX_WIDTH};
	background-color: ${({ author }) => author === 'host' ? theme.colors.BB100 : theme.colors.LM_NU30};
	color: ${({ author }) => author === 'host' ? theme.colors.LM_NU0 : theme.colors.LM_NU80};

	${theme.typography.IR100}
	line-height: ${theme.typography.lineHeight.md};

	${({ state }) => state === 'failed' &&
    `
		background-color: ${theme.colors.NE100};
		color: ${theme.colors.LM_NU0};
	`};
`;
export const StyledSpinnerForChatBubble = styled(Spinner) `
	color: ${theme.colors.BB80T};
`;
const StyledStatus = styled.div `
	text-align: ${({ author }) => (author === 'host' ? 'right' : 'left')};
	padding-top: ${theme.spacing.space10};

	${theme.typography.IR80}
	line-height: ${theme.typography.lineHeight.md};
`;
export const StyledTimestamp = styled(StyledStatus) `
	color: ${theme.colors.LM_NU70};
`;
export const StyledFailureStatus = styled(StyledStatus) `
	color: ${theme.colors.NE100};
`;
//# sourceMappingURL=SharedChatBubble.styled.js.map